
const it = {
    measure: {
        list: 'Elenco Misure',
        name: 'Nome {optionalType}',
        selectMeasure: 'Seleziona Misura',
        code: 'Codice',
        showDetail: 'Dettagli',
        mutateSubtitle: 'Modifica Misura',
        shortDescription: 'Descrizione Breve',
        description: 'Descrizione',
        thumbnail: 'Miniatura',
        selectOptional: 'Seleziona ',
        image: 'Immagine',
        group: 'Gruppo {optionalType}',
        valueMin: 'Valore Minimo',
        valueMax: 'Valore Massimo',
        unit: 'mm',
        bandelleCount: 'Numero Bandelle Cad/Anta',
        tabName: {
            MEASURE: 'Misure',
            ALTEZZA: 'Altezza',
            LARGHEZZA: 'Larghezza',

        },

    },
    measureGroup: {
        list: 'Elenco Gruppi Misure',
        mutateSubtitle: 'Modifica Gruppo Misure',
        selectMeasureGroup: 'Seleziona Gruppo Misure',
        name: 'Nome Gruppo',
        code: 'Codice',
        showDetail: 'Dettagli',
        description: 'Descrizione',
        shortDescription: 'Descrizione Breve',
        thumbnail: 'Miniatura',
        image: 'Immagine',
        tabName: {
            MEASUREGROUP: 'Gruppo Misure',

        },

    },

}
export default it